import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"



const Image = ({
  image,
  style = {},
  wrapped = false,
  loading = "lazy",
  decoding = "async",
  sizes,
  priority = false,
}) => {
  const altText = image?.alt || "";
  const resolvedLoading = priority ? "eager" : loading;
  const resolvedFetchPriority = priority ? "high" : undefined;
  if (image?.gatsbyImageData) {
    if (wrapped) {
      return (
        <div className="gatsby-image-wrapper">
          <GatsbyImage
            image={image?.gatsbyImageData}
            alt={altText}
            imgStyle={{ objectFit: "contain", ...style }}
            loading={resolvedLoading}
            decoding={decoding}
            sizes={sizes}
            fetchpriority={resolvedFetchPriority}
          />
        </div>
      )
    }
    return (
      <GatsbyImage
        image={image?.gatsbyImageData}
        alt={altText}
        imgStyle={{ objectFit: "contain", ...style }}
        loading={resolvedLoading}
        decoding={decoding}
        sizes={sizes}
        fetchpriority={resolvedFetchPriority}
      />
    );
  } else {
    return "";
  }
};

export default Image;
